/** @prettier */
var AbstractDataModel = require("./AbstractDataModel");
var DisplayPhone = require("../lib/display-phone");
var normalisedTelephoneNumber = require("../lib/phone")
  .normaliseTelephoneNumber;
var formatConsumerName = require("../lib/format-consumer-name").formatConsumerName

function ArrivalModel(arrival) {
  AbstractDataModel.call(this, arrival);

  // `arrival.name` is the `merchantInfoName`
  /**
   * @var {string}
   */
  this.name = (arrival.name) ? String(arrival.name) : "";
  this.merchantInfoName = this.name;
  this.queueId = arrival.queueId;
  this.arrived = arrival.arrived;
  this.classifier = arrival.classifier;

  this._privateName = "";
  this._phone = "";
  this._countryCode = "";

  // `arrival` element has a `phone` attribute and a `phone` child element.
  // `parseXml` groups these into an array.
  // phone[0] = private digits
  // phone[1] = phone element with country code
  if (arrival.phone && typeof arrival.phone === "object") {
    // This pattern matches the data in the Arrived List
    if (Array.isArray(arrival.phone)) {
      this._privateName = arrival.phone[0];
      this.countryCode = arrival.phone[1].countryCode;
      this.phone = arrival.phone[1].text && String(arrival.phone[1].text);
    }
  }

  if (typeof arrival.notes === 'object') {
    this.notes = (arrival.notes.text) ? arrival.notes.text : "";
  } else {
    this.notes = arrival.notes;
  }
}

Object.setPrototypeOf(ArrivalModel.prototype, AbstractDataModel.prototype);
// ArrivalModel.prototype = Object.create(AbstractDataModel.prototype);
// ArrivalModel.prototype.constructor = ArrivalModel;

ArrivalModel.prototype.queueName = function () {
  let name = "";

  if (this.queueId) {
    const queue = window.vm.queuesWS.getQueueById(this.queueId);
    name = queue ? queue.description : "";
  }

  return name
}

ArrivalModel.prototype.locationName = function () {
  let name = "";

  if (this.queueId != null) {
    const queue = window.vm.queuesWS.getQueueById(this.queueId);

    if (queue) {
      const location = window.vm.locationsWS.getLocationById(queue.locationId);
      name = location ? location.description : "";
    }
  }

  return name;
};

ArrivalModel.prototype.displayName = function () {
  var self = this;
  var q = window.vm.queuesWS.getQueueById(self.queueId);
  var displayedText = null;

  if (q) {
    var privatePhoneDigitCount = q.privatePhoneDigitCount;

    var normalisedNumber = DisplayPhone.removeDefaultCountryCode(
      normalisedTelephoneNumber(self.phone),
      self.countryCode ? self.countryCode : q.defaultPhoneCountryCode()
    );

    var privateName = window.vm.getPrivateName(
      normalisedNumber,
      self._privateName,
      false,
      privatePhoneDigitCount
    );

    // Arrival records do not have firstName or lastName, so we fake them
    // so the formatConsumerName can detect them
    var names = (this.name) ? this.name.split(" ") : [];
    var [firstName, ...lastNames ] = names;
    var lastName = lastNames.join(" ");

    displayedText = formatConsumerName({
        privateName, // already masked by `window.kiosk.getPrivateName`
        merchantInfoName: self.name,
        firstName: firstName,
        lastName: lastName,
        name: self.name,
        phone: self.phone,
        receiptNumber: self.receiptNumber
    });
  }

  return displayedText;
};

ArrivalModel.prototype.privateName = ArrivalModel.prototype.displayName;

ArrivalModel.prototype.maskedPhone = function () {
  var self = this;
  var a = null;
  var b = null;
  var matches = null;
  var phone = self.phone && String(self.phone);
  var q = window.vm.queuesWS.getQueueById(self.queueId);

  if (!phone) {
    return null;
  }

  let privatePhoneDigitCount = (q && q.privatePhoneDigitCount) || 4;

  b = phone.substring(phone.length - privatePhoneDigitCount);
  matches = b.match(/[^0-9]/g);
  privatePhoneDigitCount += (matches) ? matches.length : 0;


  a = phone.substring(0, phone.length - privatePhoneDigitCount).replace(/[0-9]/g, '#');
  b = phone.substring(phone.length - privatePhoneDigitCount);

  return a + b;
};

ArrivalModel.prototype.ticketClassifierDescription = function() {
  if (this.classifier && this.classifier.description) {
    return this.classifier.description;
  }
  else {
    return "";
  }
}

ArrivalModel.prototype.arrivedTime = function () {
  var m = moment(this.arrived.valueOf());
  return m.format('LT');
}


if (typeof exports !== "undefined") {
  module.exports = ArrivalModel;
}
